// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAuthorizedUserDto,
  IBeneficiaryDto,
  IBeneficiaryUpdateDto,
  ICombineHsaFileResponseDto,
  ICombineHsaRequestDto,
  ICreateAuthorizedUserDto,
  ICustomPageEmployeeEmployerInfoDto,
  IDependentInfoDto,
  IDependentNameDto,
  IDependentResponseDto,
  IEmployeeAutopayPropertiesDto,
  IEmployeeInfoAdminPatchDto,
  IEmployeeInfoPatchDto,
  IEmployeeInfoResponseDto,
  IEmployeeLinkResponseDto,
  IEmployeeNameDto,
  IEmployeePersonalInfoDto,
  IEmployeeViewDto,
  IEnumInfoDto,
  IErrorDto,
  IForgotUsernameRequestDto,
  IFraudReviewRequestDto,
  IGenericErrorDto,
  ILinkVerificationCodeValidationRequestDto,
  ILinkedEmployeeInfoDto,
  IMobileAppFeedbackReminderResponseDto,
  IMobileAppFeedbackRequestDto,
  IMobileAppProblemReportRequestDto,
  IPageable,
  IPersonInfoDto,
  IPersonRegistrationVerifyRequestDto,
  IPersonRegistrationVerifyResponseDto,
  IPublicEmployeeInfoDto,
  ISsnInfoDto,
  ISsoUserSignUpDto,
  IUpdateAuthorizedUserDto,
  IUsernameRegistrationVerifyRequestDto,
  IVerificationCodeRequestCreateDto,
  IVerificationCodeValidationRequestDto,
  IVerificationCodeValidationResponseDto,
} from '../models/index';
import {
    IAuthorizedUserDtoFromJSON,
    IAuthorizedUserDtoToJSON,
    IBeneficiaryDtoFromJSON,
    IBeneficiaryDtoToJSON,
    IBeneficiaryUpdateDtoFromJSON,
    IBeneficiaryUpdateDtoToJSON,
    ICombineHsaFileResponseDtoFromJSON,
    ICombineHsaFileResponseDtoToJSON,
    ICombineHsaRequestDtoFromJSON,
    ICombineHsaRequestDtoToJSON,
    ICreateAuthorizedUserDtoFromJSON,
    ICreateAuthorizedUserDtoToJSON,
    ICustomPageEmployeeEmployerInfoDtoFromJSON,
    ICustomPageEmployeeEmployerInfoDtoToJSON,
    IDependentInfoDtoFromJSON,
    IDependentInfoDtoToJSON,
    IDependentNameDtoFromJSON,
    IDependentNameDtoToJSON,
    IDependentResponseDtoFromJSON,
    IDependentResponseDtoToJSON,
    IEmployeeAutopayPropertiesDtoFromJSON,
    IEmployeeAutopayPropertiesDtoToJSON,
    IEmployeeInfoAdminPatchDtoFromJSON,
    IEmployeeInfoAdminPatchDtoToJSON,
    IEmployeeInfoPatchDtoFromJSON,
    IEmployeeInfoPatchDtoToJSON,
    IEmployeeInfoResponseDtoFromJSON,
    IEmployeeInfoResponseDtoToJSON,
    IEmployeeLinkResponseDtoFromJSON,
    IEmployeeLinkResponseDtoToJSON,
    IEmployeeNameDtoFromJSON,
    IEmployeeNameDtoToJSON,
    IEmployeePersonalInfoDtoFromJSON,
    IEmployeePersonalInfoDtoToJSON,
    IEmployeeViewDtoFromJSON,
    IEmployeeViewDtoToJSON,
    IEnumInfoDtoFromJSON,
    IEnumInfoDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IForgotUsernameRequestDtoFromJSON,
    IForgotUsernameRequestDtoToJSON,
    IFraudReviewRequestDtoFromJSON,
    IFraudReviewRequestDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    ILinkVerificationCodeValidationRequestDtoFromJSON,
    ILinkVerificationCodeValidationRequestDtoToJSON,
    ILinkedEmployeeInfoDtoFromJSON,
    ILinkedEmployeeInfoDtoToJSON,
    IMobileAppFeedbackReminderResponseDtoFromJSON,
    IMobileAppFeedbackReminderResponseDtoToJSON,
    IMobileAppFeedbackRequestDtoFromJSON,
    IMobileAppFeedbackRequestDtoToJSON,
    IMobileAppProblemReportRequestDtoFromJSON,
    IMobileAppProblemReportRequestDtoToJSON,
    IPageableFromJSON,
    IPageableToJSON,
    IPersonInfoDtoFromJSON,
    IPersonInfoDtoToJSON,
    IPersonRegistrationVerifyRequestDtoFromJSON,
    IPersonRegistrationVerifyRequestDtoToJSON,
    IPersonRegistrationVerifyResponseDtoFromJSON,
    IPersonRegistrationVerifyResponseDtoToJSON,
    IPublicEmployeeInfoDtoFromJSON,
    IPublicEmployeeInfoDtoToJSON,
    ISsnInfoDtoFromJSON,
    ISsnInfoDtoToJSON,
    ISsoUserSignUpDtoFromJSON,
    ISsoUserSignUpDtoToJSON,
    IUpdateAuthorizedUserDtoFromJSON,
    IUpdateAuthorizedUserDtoToJSON,
    IUsernameRegistrationVerifyRequestDtoFromJSON,
    IUsernameRegistrationVerifyRequestDtoToJSON,
    IVerificationCodeRequestCreateDtoFromJSON,
    IVerificationCodeRequestCreateDtoToJSON,
    IVerificationCodeValidationRequestDtoFromJSON,
    IVerificationCodeValidationRequestDtoToJSON,
    IVerificationCodeValidationResponseDtoFromJSON,
    IVerificationCodeValidationResponseDtoToJSON,
} from '../models/index';

export interface ActivateRequest {
    id: number;
}

export interface AddCardForDependentRequest {
    dependentId: number;
}

export interface CombineHsaRequest {
    employeeId: number;
    accountId: number;
    iCombineHsaRequestDto: ICombineHsaRequestDto;
}

export interface ConfirmAddressRequest {
    addressId: number;
}

export interface ConfirmFraudRequest {
    employeeId: number;
}

export interface CreateAuthorizedUserRequest {
    iCreateAuthorizedUserDto: ICreateAuthorizedUserDto;
}

export interface CreateBeneficiariesRequest {
    employeeId: number;
    iBeneficiaryUpdateDto: Array<IBeneficiaryUpdateDto>;
}

export interface CreateMobileAppFeedbackRequest {
    iMobileAppFeedbackRequestDto: IMobileAppFeedbackRequestDto;
}

export interface CreateMobileAppProblemReportRequest {
    iMobileAppProblemReportRequestDto: IMobileAppProblemReportRequestDto;
}

export interface CreateVerificationCode1Request {
    iVerificationCodeRequestCreateDto: IVerificationCodeRequestCreateDto;
}

export interface DeactivateRequest {
    id: number;
}

export interface DeactivateDependentRequest {
    dependentId: number;
}

export interface DeleteByEmployeeIdAndTypeRequest {
    employeeId: number;
    type: DeleteByEmployeeIdAndTypeTypeEnum;
}

export interface DeleteDependentRequest {
    dependentId: number;
}

export interface GetByEmployeeIdRequest {
    employeeId: number;
}

export interface GetByEmployeeId1Request {
    employeeId: number;
    pageable: IPageable;
    status?: Set<GetByEmployeeId1StatusEnum>;
}

export interface GetDependentRequest {
    dependentId: number;
    statuses?: Set<GetDependentStatusesEnum>;
}

export interface GetDependent1Request {
    dependentId: number;
    statuses?: Set<GetDependent1StatusesEnum>;
}

export interface GetDependentNamesByEmployeeIdRequest {
    employeeId: number;
}

export interface GetDependentNamesByEmployeeId1Request {
    employeeId: number;
}

export interface GetDependentsByEmployeeIdRequest {
    employeeId: number;
    statuses?: Set<GetDependentsByEmployeeIdStatusesEnum>;
}

export interface GetDependentsByEmployeeId2Request {
    employeeId: number;
}

export interface GetEmployee1Request {
    employeeId: number;
}

export interface GetEmployeeInfoRequest {
    employeeId: number;
}

export interface GetEmployeeInternalRequest {
    employeeId: number;
}

export interface GetEmployeePersonalInfo1Request {
    employeeId: number;
}

export interface GetEmployeeSsnRequest {
    employeeId: number;
}

export interface GetEmployeeViewRequest {
    employeeId: number;
}

export interface GetEmployeesNamesByIdsRequest {
    ids: Set<number>;
}

export interface GetLinkedEmployeesRequest {
    employeeId: number;
}

export interface GetPersonRequest {
    personId: number;
    xDETAILSRESOLVERS?: Set<GetPersonXDetailsResolversEnum>;
}

export interface LinkEmployeesRequest {
    employeeId: number;
    requestBody?: Set<number>;
}

export interface LinkEmployeesSearchRequest {
    employeeId?: number;
    status?: LinkEmployeesSearchStatusEnum;
    searchValue?: string;
    organizationId?: number;
    personId?: number;
    birthOn?: Date;
    ssn?: string;
    employerEmployeeId?: string;
    partnerEmployeeId?: string;
    firstName?: string;
    lastName?: string;
    employeeIds?: Set<number>;
}

export interface PatchEmployeeInfoRequest {
    iEmployeeInfoPatchDto: IEmployeeInfoPatchDto;
}

export interface PatchEmployeeInfo1Request {
    employeeId: number;
    iEmployeeInfoAdminPatchDto: IEmployeeInfoAdminPatchDto;
}

export interface PersonForgotUsernameRequest {
    iForgotUsernameRequestDto: IForgotUsernameRequestDto;
    userAgent?: string;
}

export interface PersonVerifyCodeFromLinkRequest {
    iLinkVerificationCodeValidationRequestDto: ILinkVerificationCodeValidationRequestDto;
}

export interface ReactivateDependentRequest {
    dependentId: number;
}

export interface SearchAdminEmployeeRequest {
    status?: SearchAdminEmployeeStatusEnum;
    searchValue?: string;
    organizationId?: number;
    personId?: number;
    birthOn?: Date;
    ssn?: string;
    employerEmployeeId?: string;
    partnerEmployeeId?: string;
    firstName?: string;
    lastName?: string;
    employeeIds?: Set<number>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SearchAdminEmployeeIdsRequest {
    status?: SearchAdminEmployeeIdsStatusEnum;
    searchValue?: string;
    organizationId?: number;
    personId?: number;
    birthOn?: Date;
    ssn?: string;
    employerEmployeeId?: string;
    partnerEmployeeId?: string;
    firstName?: string;
    lastName?: string;
    employeeIds?: Set<number>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SearchEmployee2Request {
    status?: SearchEmployee2StatusEnum;
    searchValue?: string;
    organizationId?: number;
    personId?: number;
    birthOn?: Date;
    ssn?: string;
    employerEmployeeId?: string;
    partnerEmployeeId?: string;
    firstName?: string;
    lastName?: string;
    employeeIds?: Set<number>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SignUpSsoUserRequest {
    employeeId: number;
    iSsoUserSignUpDto: ISsoUserSignUpDto;
}

export interface UpdateAuthorizedUserRequest {
    id: number;
    iUpdateAuthorizedUserDto: IUpdateAuthorizedUserDto;
}

export interface UpdateBeneficiariesRequest {
    employeeId: number;
    iBeneficiaryUpdateDto: Array<IBeneficiaryUpdateDto>;
}

export interface UpdateEmployeeAutopayPropertiesRequest {
    employeeId: number;
    iEmployeeAutopayPropertiesDto: IEmployeeAutopayPropertiesDto;
}

export interface UpdateFraudReviewStatus1Request {
    employeeId: number;
    iFraudReviewRequestDto: IFraudReviewRequestDto;
}

export interface UpdateLinkedCognitoRequest {
    employeeId?: number;
}

export interface UploadCombineHsaDocFileRequest {
    employeeId: number;
    file: Blob;
}

export interface VerifyCodeRequest {
    iVerificationCodeValidationRequestDto: IVerificationCodeValidationRequestDto;
}

export interface VerifyPersonRegistrationRequest {
    iPersonRegistrationVerifyRequestDto: IPersonRegistrationVerifyRequestDto;
    userAgent?: string;
}

export interface VerifyUsernamesRegistrationRequest {
    iUsernameRegistrationVerifyRequestDto: IUsernameRegistrationVerifyRequestDto;
}

/**
 * PersonServiceServiceApi - interface
 * 
 * @export
 * @interface PersonServiceServiceApiInterface
 */
export interface PersonServiceServiceApiInterface {
    /**
     * 
     * @summary Activate an authorized user
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    activateRaw(requestParameters: ActivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Activate an authorized user
     */
    activate(requestParameters: ActivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Add card for dependent
     * @param {number} dependentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    addCardForDependentRaw(requestParameters: AddCardForDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Add card for dependent
     */
    addCardForDependent(requestParameters: AddCardForDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Validates and initiates HSA account combination from one account to another
     * @summary Combine HSA accounts
     * @param {number} employeeId 
     * @param {number} accountId 
     * @param {ICombineHsaRequestDto} iCombineHsaRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    combineHsaRaw(requestParameters: CombineHsaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validates and initiates HSA account combination from one account to another
     * Combine HSA accounts
     */
    combineHsa(requestParameters: CombineHsaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    confirmAddressRaw(requestParameters: ConfirmAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    confirmAddress(requestParameters: ConfirmAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Confirm fraud for an employee (irreversible)
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    confirmFraudRaw(requestParameters: ConfirmFraudRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Confirm fraud for an employee (irreversible)
     */
    confirmFraud(requestParameters: ConfirmFraudRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Create an authorized user
     * @param {ICreateAuthorizedUserDto} iCreateAuthorizedUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    createAuthorizedUserRaw(requestParameters: CreateAuthorizedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAuthorizedUserDto>>;

    /**
     * Create an authorized user
     */
    createAuthorizedUser(requestParameters: CreateAuthorizedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAuthorizedUserDto>;

    /**
     * 
     * @summary Create multiple beneficiaries for an employee
     * @param {number} employeeId 
     * @param {Array<IBeneficiaryUpdateDto>} iBeneficiaryUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    createBeneficiariesRaw(requestParameters: CreateBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IBeneficiaryDto>>>;

    /**
     * Create multiple beneficiaries for an employee
     */
    createBeneficiaries(requestParameters: CreateBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IBeneficiaryDto>>;

    /**
     * 
     * @param {IMobileAppFeedbackRequestDto} iMobileAppFeedbackRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    createMobileAppFeedbackRaw(requestParameters: CreateMobileAppFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    createMobileAppFeedback(requestParameters: CreateMobileAppFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IMobileAppProblemReportRequestDto} iMobileAppProblemReportRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    createMobileAppProblemReportRaw(requestParameters: CreateMobileAppProblemReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    createMobileAppProblemReport(requestParameters: CreateMobileAppProblemReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IVerificationCodeRequestCreateDto} iVerificationCodeRequestCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    createVerificationCode1Raw(requestParameters: CreateVerificationCode1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVerificationCodeRequestCreateDto>>;

    /**
     */
    createVerificationCode1(requestParameters: CreateVerificationCode1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVerificationCodeRequestCreateDto>;

    /**
     * 
     * @summary Deactivate an authorized user
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    deactivateRaw(requestParameters: DeactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deactivate an authorized user
     */
    deactivate(requestParameters: DeactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Deactivate dependent
     * @param {number} dependentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    deactivateDependentRaw(requestParameters: DeactivateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deactivate dependent
     */
    deactivateDependent(requestParameters: DeactivateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete all beneficiaries of a specific type for an employee
     * @param {number} employeeId 
     * @param {'PRIMARY' | 'CONTINGENT'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    deleteByEmployeeIdAndTypeRaw(requestParameters: DeleteByEmployeeIdAndTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete all beneficiaries of a specific type for an employee
     */
    deleteByEmployeeIdAndType(requestParameters: DeleteByEmployeeIdAndTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} dependentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    deleteDependentRaw(requestParameters: DeleteDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteDependent(requestParameters: DeleteDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get all existing BeneficiaryRelationshipType enums
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getBeneficiaryRelationshipTypeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumInfoDto>>>;

    /**
     * Get all existing BeneficiaryRelationshipType enums
     */
    getBeneficiaryRelationshipType(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumInfoDto>>;

    /**
     * 
     * @summary Get all beneficiaries for an employee
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getByEmployeeIdRaw(requestParameters: GetByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IBeneficiaryDto>>>;

    /**
     * Get all beneficiaries for an employee
     */
    getByEmployeeId(requestParameters: GetByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IBeneficiaryDto>>;

    /**
     * 
     * @summary Get authorized users by employee ID
     * @param {number} employeeId 
     * @param {IPageable} pageable 
     * @param {Set<'ACTIVE' | 'INACTIVE'>} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getByEmployeeId1Raw(requestParameters: GetByEmployeeId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAuthorizedUserDto>>;

    /**
     * Get authorized users by employee ID
     */
    getByEmployeeId1(requestParameters: GetByEmployeeId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAuthorizedUserDto>;

    /**
     * 
     * @summary Get dependent
     * @param {number} dependentId 
     * @param {Set<'ACTIVE' | 'INACTIVE'>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getDependentRaw(requestParameters: GetDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentResponseDto>>;

    /**
     * Get dependent
     */
    getDependent(requestParameters: GetDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentResponseDto>;

    /**
     * 
     * @param {number} dependentId 
     * @param {Set<'ACTIVE' | 'INACTIVE'>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getDependent1Raw(requestParameters: GetDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentInfoDto>>;

    /**
     */
    getDependent1(requestParameters: GetDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentInfoDto>;

    /**
     * 
     * @summary Get dependent names by employee ID
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getDependentNamesByEmployeeIdRaw(requestParameters: GetDependentNamesByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IDependentNameDto>>>;

    /**
     * Get dependent names by employee ID
     */
    getDependentNamesByEmployeeId(requestParameters: GetDependentNamesByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IDependentNameDto>>;

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getDependentNamesByEmployeeId1Raw(requestParameters: GetDependentNamesByEmployeeId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IDependentNameDto>>>;

    /**
     */
    getDependentNamesByEmployeeId1(requestParameters: GetDependentNamesByEmployeeId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IDependentNameDto>>;

    /**
     * 
     * @summary Get dependents by employee ID
     * @param {number} employeeId 
     * @param {Set<'ACTIVE' | 'INACTIVE'>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getDependentsByEmployeeIdRaw(requestParameters: GetDependentsByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentResponseDto>>;

    /**
     * Get dependents by employee ID
     */
    getDependentsByEmployeeId(requestParameters: GetDependentsByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentResponseDto>;

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getDependentsByEmployeeId2Raw(requestParameters: GetDependentsByEmployeeId2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentInfoDto>>;

    /**
     */
    getDependentsByEmployeeId2(requestParameters: GetDependentsByEmployeeId2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentInfoDto>;

    /**
     * 
     * @summary Get public employee information by ID (secure, hides bad employees)
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getEmployee1Raw(requestParameters: GetEmployee1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicEmployeeInfoDto>>;

    /**
     * Get public employee information by ID (secure, hides bad employees)
     */
    getEmployee1(requestParameters: GetEmployee1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicEmployeeInfoDto>;

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getEmployeeInfoRaw(requestParameters: GetEmployeeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoResponseDto>>;

    /**
     */
    getEmployeeInfo(requestParameters: GetEmployeeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoResponseDto>;

    /**
     * 
     * @summary Get public employee information by ID (internal, returns de-identified data for bad employees)
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getEmployeeInternalRaw(requestParameters: GetEmployeeInternalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicEmployeeInfoDto>>;

    /**
     * Get public employee information by ID (internal, returns de-identified data for bad employees)
     */
    getEmployeeInternal(requestParameters: GetEmployeeInternalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicEmployeeInfoDto>;

    /**
     * 
     * @summary Get employee personal information by ID
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getEmployeePersonalInfo1Raw(requestParameters: GetEmployeePersonalInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeePersonalInfoDto>>;

    /**
     * Get employee personal information by ID
     */
    getEmployeePersonalInfo1(requestParameters: GetEmployeePersonalInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeePersonalInfoDto>;

    /**
     * 
     * @summary Get employee SSN by ID
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getEmployeeSsnRaw(requestParameters: GetEmployeeSsnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISsnInfoDto>>;

    /**
     * Get employee SSN by ID
     */
    getEmployeeSsn(requestParameters: GetEmployeeSsnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISsnInfoDto>;

    /**
     * 
     * @summary Get employee view information by ID
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getEmployeeViewRaw(requestParameters: GetEmployeeViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeViewDto>>;

    /**
     * Get employee view information by ID
     */
    getEmployeeView(requestParameters: GetEmployeeViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeViewDto>;

    /**
     * 
     * @summary Get employee names by list of IDs
     * @param {Set<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getEmployeesNamesByIdsRaw(requestParameters: GetEmployeesNamesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmployeeNameDto>>>;

    /**
     * Get employee names by list of IDs
     */
    getEmployeesNamesByIds(requestParameters: GetEmployeesNamesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmployeeNameDto>>;

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getLinkedEmployeesRaw(requestParameters: GetLinkedEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeLinkResponseDto>>;

    /**
     */
    getLinkedEmployees(requestParameters: GetLinkedEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeLinkResponseDto>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getMobileAppFeedbackConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IMobileAppFeedbackReminderResponseDto>>;

    /**
     */
    getMobileAppFeedbackConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IMobileAppFeedbackReminderResponseDto>;

    /**
     * 
     * @param {number} personId 
     * @param {Set<'DEPENDENT' | 'SSN' | 'ADDRESS'>} [xDETAILSRESOLVERS] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    getPersonRaw(requestParameters: GetPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPersonInfoDto>>;

    /**
     */
    getPerson(requestParameters: GetPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPersonInfoDto>;

    /**
     * 
     * @param {number} employeeId 
     * @param {Set<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    linkEmployeesRaw(requestParameters: LinkEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeLinkResponseDto>>;

    /**
     */
    linkEmployees(requestParameters: LinkEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeLinkResponseDto>;

    /**
     * 
     * @param {number} [employeeId] 
     * @param {'A' | 'T' | 'L' | 'R' | 'F' | 'C'} [status] 
     * @param {string} [searchValue] 
     * @param {number} [organizationId] 
     * @param {number} [personId] 
     * @param {Date} [birthOn] 
     * @param {string} [ssn] 
     * @param {string} [employerEmployeeId] 
     * @param {string} [partnerEmployeeId] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {Set<number>} [employeeIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    linkEmployeesSearchRaw(requestParameters: LinkEmployeesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILinkedEmployeeInfoDto>>;

    /**
     */
    linkEmployeesSearch(requestParameters: LinkEmployeesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILinkedEmployeeInfoDto>;

    /**
     * 
     * @summary Patch employee info
     * @param {IEmployeeInfoPatchDto} iEmployeeInfoPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    patchEmployeeInfoRaw(requestParameters: PatchEmployeeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoPatchDto>>;

    /**
     * Patch employee info
     */
    patchEmployeeInfo(requestParameters: PatchEmployeeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoPatchDto>;

    /**
     * 
     * @summary Patch employee info
     * @param {number} employeeId 
     * @param {IEmployeeInfoAdminPatchDto} iEmployeeInfoAdminPatchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    patchEmployeeInfo1Raw(requestParameters: PatchEmployeeInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoAdminPatchDto>>;

    /**
     * Patch employee info
     */
    patchEmployeeInfo1(requestParameters: PatchEmployeeInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoAdminPatchDto>;

    /**
     * 
     * @param {IForgotUsernameRequestDto} iForgotUsernameRequestDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    personForgotUsernameRaw(requestParameters: PersonForgotUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    personForgotUsername(requestParameters: PersonForgotUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {ILinkVerificationCodeValidationRequestDto} iLinkVerificationCodeValidationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    personVerifyCodeFromLinkRaw(requestParameters: PersonVerifyCodeFromLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVerificationCodeValidationResponseDto>>;

    /**
     */
    personVerifyCodeFromLink(requestParameters: PersonVerifyCodeFromLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVerificationCodeValidationResponseDto>;

    /**
     * 
     * @summary Reactivate dependent
     * @param {number} dependentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    reactivateDependentRaw(requestParameters: ReactivateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reactivate dependent
     */
    reactivateDependent(requestParameters: ReactivateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Search employees with employer info for admin use
     * @param {'A' | 'T' | 'L' | 'R' | 'F' | 'C'} [status] 
     * @param {string} [searchValue] 
     * @param {number} [organizationId] 
     * @param {number} [personId] 
     * @param {Date} [birthOn] 
     * @param {string} [ssn] 
     * @param {string} [employerEmployeeId] 
     * @param {string} [partnerEmployeeId] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {Set<number>} [employeeIds] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    searchAdminEmployeeRaw(requestParameters: SearchAdminEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageEmployeeEmployerInfoDto>>;

    /**
     * Search employees with employer info for admin use
     */
    searchAdminEmployee(requestParameters: SearchAdminEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageEmployeeEmployerInfoDto>;

    /**
     * 
     * @summary Search employee IDs for admin use
     * @param {'A' | 'T' | 'L' | 'R' | 'F' | 'C'} [status] 
     * @param {string} [searchValue] 
     * @param {number} [organizationId] 
     * @param {number} [personId] 
     * @param {Date} [birthOn] 
     * @param {string} [ssn] 
     * @param {string} [employerEmployeeId] 
     * @param {string} [partnerEmployeeId] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {Set<number>} [employeeIds] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    searchAdminEmployeeIdsRaw(requestParameters: SearchAdminEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>>;

    /**
     * Search employee IDs for admin use
     */
    searchAdminEmployeeIds(requestParameters: SearchAdminEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number>;

    /**
     * 
     * @summary Search employees with public info (hides bad employees)
     * @param {'A' | 'T' | 'L' | 'R' | 'F' | 'C'} [status] 
     * @param {string} [searchValue] 
     * @param {number} [organizationId] 
     * @param {number} [personId] 
     * @param {Date} [birthOn] 
     * @param {string} [ssn] 
     * @param {string} [employerEmployeeId] 
     * @param {string} [partnerEmployeeId] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {Set<number>} [employeeIds] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    searchEmployee2Raw(requestParameters: SearchEmployee2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicEmployeeInfoDto>>;

    /**
     * Search employees with public info (hides bad employees)
     */
    searchEmployee2(requestParameters: SearchEmployee2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicEmployeeInfoDto>;

    /**
     * 
     * @summary Start orphan process
     * @param {number} employeeId 
     * @param {ISsoUserSignUpDto} iSsoUserSignUpDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    signUpSsoUserRaw(requestParameters: SignUpSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicEmployeeInfoDto>>;

    /**
     * Start orphan process
     */
    signUpSsoUser(requestParameters: SignUpSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicEmployeeInfoDto>;

    /**
     * 
     * @summary Update an authorized user
     * @param {number} id 
     * @param {IUpdateAuthorizedUserDto} iUpdateAuthorizedUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    updateAuthorizedUserRaw(requestParameters: UpdateAuthorizedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAuthorizedUserDto>>;

    /**
     * Update an authorized user
     */
    updateAuthorizedUser(requestParameters: UpdateAuthorizedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAuthorizedUserDto>;

    /**
     * 
     * @summary Update beneficiaries for an employee
     * @param {number} employeeId 
     * @param {Array<IBeneficiaryUpdateDto>} iBeneficiaryUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    updateBeneficiariesRaw(requestParameters: UpdateBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IBeneficiaryDto>>>;

    /**
     * Update beneficiaries for an employee
     */
    updateBeneficiaries(requestParameters: UpdateBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IBeneficiaryDto>>;

    /**
     * 
     * @summary Update employee autopay properties
     * @param {number} employeeId 
     * @param {IEmployeeAutopayPropertiesDto} iEmployeeAutopayPropertiesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    updateEmployeeAutopayPropertiesRaw(requestParameters: UpdateEmployeeAutopayPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeAutopayPropertiesDto>>;

    /**
     * Update employee autopay properties
     */
    updateEmployeeAutopayProperties(requestParameters: UpdateEmployeeAutopayPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeAutopayPropertiesDto>;

    /**
     * 
     * @summary Set or remove fraud review flag for an employee
     * @param {number} employeeId 
     * @param {IFraudReviewRequestDto} iFraudReviewRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    updateFraudReviewStatus1Raw(requestParameters: UpdateFraudReviewStatus1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Set or remove fraud review flag for an employee
     */
    updateFraudReviewStatus1(requestParameters: UpdateFraudReviewStatus1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    updateLinkedCognitoRaw(requestParameters: UpdateLinkedCognitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    updateLinkedCognito(requestParameters: UpdateLinkedCognitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Upload combine hsa document file
     * @param {number} employeeId 
     * @param {Blob} file File to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    uploadCombineHsaDocFileRaw(requestParameters: UploadCombineHsaDocFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICombineHsaFileResponseDto>>;

    /**
     * Upload combine hsa document file
     */
    uploadCombineHsaDocFile(requestParameters: UploadCombineHsaDocFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICombineHsaFileResponseDto>;

    /**
     * 
     * @param {IVerificationCodeValidationRequestDto} iVerificationCodeValidationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    verifyCodeRaw(requestParameters: VerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVerificationCodeValidationResponseDto>>;

    /**
     */
    verifyCode(requestParameters: VerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVerificationCodeValidationResponseDto>;

    /**
     * 
     * @param {IPersonRegistrationVerifyRequestDto} iPersonRegistrationVerifyRequestDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    verifyPersonRegistrationRaw(requestParameters: VerifyPersonRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPersonRegistrationVerifyResponseDto>>;

    /**
     */
    verifyPersonRegistration(requestParameters: VerifyPersonRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPersonRegistrationVerifyResponseDto>;

    /**
     * 
     * @param {IUsernameRegistrationVerifyRequestDto} iUsernameRegistrationVerifyRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonServiceServiceApiInterface
     */
    verifyUsernamesRegistrationRaw(requestParameters: VerifyUsernamesRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    verifyUsernamesRegistration(requestParameters: VerifyUsernamesRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PersonServiceServiceApi extends runtime.BaseAPI implements PersonServiceServiceApiInterface {

    /**
     * Activate an authorized user
     */
    async activateRaw(requestParameters: ActivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling activate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/authorized-users/{id}/activate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Activate an authorized user
     */
    async activate(requestParameters: ActivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.activateRaw(requestParameters, initOverrides);
    }

    /**
     * Add card for dependent
     */
    async addCardForDependentRaw(requestParameters: AddCardForDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dependentId'] == null) {
            throw new runtime.RequiredError(
                'dependentId',
                'Required parameter "dependentId" was null or undefined when calling addCardForDependent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/dependents/{dependent-id}/add-card`;
        urlPath = urlPath.replace(`{${"dependent-id"}}`, encodeURIComponent(String(requestParameters['dependentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add card for dependent
     */
    async addCardForDependent(requestParameters: AddCardForDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addCardForDependentRaw(requestParameters, initOverrides);
    }

    /**
     * Validates and initiates HSA account combination from one account to another
     * Combine HSA accounts
     */
    async combineHsaRaw(requestParameters: CombineHsaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling combineHsa().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling combineHsa().'
            );
        }

        if (requestParameters['iCombineHsaRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCombineHsaRequestDto',
                'Required parameter "iCombineHsaRequestDto" was null or undefined when calling combineHsa().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/account/{account-id}/combine-with-hsa`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));
        urlPath = urlPath.replace(`{${"account-id"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICombineHsaRequestDtoToJSON(requestParameters['iCombineHsaRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates and initiates HSA account combination from one account to another
     * Combine HSA accounts
     */
    async combineHsa(requestParameters: CombineHsaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.combineHsaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async confirmAddressRaw(requestParameters: ConfirmAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['addressId'] == null) {
            throw new runtime.RequiredError(
                'addressId',
                'Required parameter "addressId" was null or undefined when calling confirmAddress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/addresses/{address-id}/confirm`;
        urlPath = urlPath.replace(`{${"address-id"}}`, encodeURIComponent(String(requestParameters['addressId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async confirmAddress(requestParameters: ConfirmAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmAddressRaw(requestParameters, initOverrides);
    }

    /**
     * Confirm fraud for an employee (irreversible)
     */
    async confirmFraudRaw(requestParameters: ConfirmFraudRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling confirmFraud().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/fraud-confirm`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm fraud for an employee (irreversible)
     */
    async confirmFraud(requestParameters: ConfirmFraudRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmFraudRaw(requestParameters, initOverrides);
    }

    /**
     * Create an authorized user
     */
    async createAuthorizedUserRaw(requestParameters: CreateAuthorizedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAuthorizedUserDto>> {
        if (requestParameters['iCreateAuthorizedUserDto'] == null) {
            throw new runtime.RequiredError(
                'iCreateAuthorizedUserDto',
                'Required parameter "iCreateAuthorizedUserDto" was null or undefined when calling createAuthorizedUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/authorized-users`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateAuthorizedUserDtoToJSON(requestParameters['iCreateAuthorizedUserDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAuthorizedUserDtoFromJSON(jsonValue));
    }

    /**
     * Create an authorized user
     */
    async createAuthorizedUser(requestParameters: CreateAuthorizedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAuthorizedUserDto> {
        const response = await this.createAuthorizedUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create multiple beneficiaries for an employee
     */
    async createBeneficiariesRaw(requestParameters: CreateBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IBeneficiaryDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling createBeneficiaries().'
            );
        }

        if (requestParameters['iBeneficiaryUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iBeneficiaryUpdateDto',
                'Required parameter "iBeneficiaryUpdateDto" was null or undefined when calling createBeneficiaries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/beneficiaries`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['iBeneficiaryUpdateDto']!.map(IBeneficiaryUpdateDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IBeneficiaryDtoFromJSON));
    }

    /**
     * Create multiple beneficiaries for an employee
     */
    async createBeneficiaries(requestParameters: CreateBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IBeneficiaryDto>> {
        const response = await this.createBeneficiariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createMobileAppFeedbackRaw(requestParameters: CreateMobileAppFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iMobileAppFeedbackRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iMobileAppFeedbackRequestDto',
                'Required parameter "iMobileAppFeedbackRequestDto" was null or undefined when calling createMobileAppFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/mobile-app/feedback`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IMobileAppFeedbackRequestDtoToJSON(requestParameters['iMobileAppFeedbackRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createMobileAppFeedback(requestParameters: CreateMobileAppFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMobileAppFeedbackRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createMobileAppProblemReportRaw(requestParameters: CreateMobileAppProblemReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iMobileAppProblemReportRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iMobileAppProblemReportRequestDto',
                'Required parameter "iMobileAppProblemReportRequestDto" was null or undefined when calling createMobileAppProblemReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/mobile-app/problem-report`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IMobileAppProblemReportRequestDtoToJSON(requestParameters['iMobileAppProblemReportRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createMobileAppProblemReport(requestParameters: CreateMobileAppProblemReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMobileAppProblemReportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createVerificationCode1Raw(requestParameters: CreateVerificationCode1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVerificationCodeRequestCreateDto>> {
        if (requestParameters['iVerificationCodeRequestCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iVerificationCodeRequestCreateDto',
                'Required parameter "iVerificationCodeRequestCreateDto" was null or undefined when calling createVerificationCode1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/codes/verifications`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IVerificationCodeRequestCreateDtoToJSON(requestParameters['iVerificationCodeRequestCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IVerificationCodeRequestCreateDtoFromJSON(jsonValue));
    }

    /**
     */
    async createVerificationCode1(requestParameters: CreateVerificationCode1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVerificationCodeRequestCreateDto> {
        const response = await this.createVerificationCode1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate an authorized user
     */
    async deactivateRaw(requestParameters: DeactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deactivate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/authorized-users/{id}/deactivate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deactivate an authorized user
     */
    async deactivate(requestParameters: DeactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivateRaw(requestParameters, initOverrides);
    }

    /**
     * Deactivate dependent
     */
    async deactivateDependentRaw(requestParameters: DeactivateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dependentId'] == null) {
            throw new runtime.RequiredError(
                'dependentId',
                'Required parameter "dependentId" was null or undefined when calling deactivateDependent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/dependents/{dependent-id}/deactivate`;
        urlPath = urlPath.replace(`{${"dependent-id"}}`, encodeURIComponent(String(requestParameters['dependentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deactivate dependent
     */
    async deactivateDependent(requestParameters: DeactivateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivateDependentRaw(requestParameters, initOverrides);
    }

    /**
     * Delete all beneficiaries of a specific type for an employee
     */
    async deleteByEmployeeIdAndTypeRaw(requestParameters: DeleteByEmployeeIdAndTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling deleteByEmployeeIdAndType().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling deleteByEmployeeIdAndType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/beneficiaries/{type}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete all beneficiaries of a specific type for an employee
     */
    async deleteByEmployeeIdAndType(requestParameters: DeleteByEmployeeIdAndTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteByEmployeeIdAndTypeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteDependentRaw(requestParameters: DeleteDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dependentId'] == null) {
            throw new runtime.RequiredError(
                'dependentId',
                'Required parameter "dependentId" was null or undefined when calling deleteDependent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dependents/{dependent-id}`;
        urlPath = urlPath.replace(`{${"dependent-id"}}`, encodeURIComponent(String(requestParameters['dependentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDependent(requestParameters: DeleteDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDependentRaw(requestParameters, initOverrides);
    }

    /**
     * Get all existing BeneficiaryRelationshipType enums
     */
    async getBeneficiaryRelationshipTypeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEnumInfoDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/beneficiary-relationship-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEnumInfoDtoFromJSON));
    }

    /**
     * Get all existing BeneficiaryRelationshipType enums
     */
    async getBeneficiaryRelationshipType(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEnumInfoDto>> {
        const response = await this.getBeneficiaryRelationshipTypeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all beneficiaries for an employee
     */
    async getByEmployeeIdRaw(requestParameters: GetByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IBeneficiaryDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getByEmployeeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/beneficiaries`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IBeneficiaryDtoFromJSON));
    }

    /**
     * Get all beneficiaries for an employee
     */
    async getByEmployeeId(requestParameters: GetByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IBeneficiaryDto>> {
        const response = await this.getByEmployeeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get authorized users by employee ID
     */
    async getByEmployeeId1Raw(requestParameters: GetByEmployeeId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAuthorizedUserDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getByEmployeeId1().'
            );
        }

        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling getByEmployeeId1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/authorized-users`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAuthorizedUserDtoFromJSON(jsonValue));
    }

    /**
     * Get authorized users by employee ID
     */
    async getByEmployeeId1(requestParameters: GetByEmployeeId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAuthorizedUserDto> {
        const response = await this.getByEmployeeId1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dependent
     */
    async getDependentRaw(requestParameters: GetDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentResponseDto>> {
        if (requestParameters['dependentId'] == null) {
            throw new runtime.RequiredError(
                'dependentId',
                'Required parameter "dependentId" was null or undefined when calling getDependent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/dependents/{dependent-id}`;
        urlPath = urlPath.replace(`{${"dependent-id"}}`, encodeURIComponent(String(requestParameters['dependentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDependentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get dependent
     */
    async getDependent(requestParameters: GetDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentResponseDto> {
        const response = await this.getDependentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDependent1Raw(requestParameters: GetDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentInfoDto>> {
        if (requestParameters['dependentId'] == null) {
            throw new runtime.RequiredError(
                'dependentId',
                'Required parameter "dependentId" was null or undefined when calling getDependent1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dependents/{dependent-id}`;
        urlPath = urlPath.replace(`{${"dependent-id"}}`, encodeURIComponent(String(requestParameters['dependentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDependentInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDependent1(requestParameters: GetDependent1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentInfoDto> {
        const response = await this.getDependent1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dependent names by employee ID
     */
    async getDependentNamesByEmployeeIdRaw(requestParameters: GetDependentNamesByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IDependentNameDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getDependentNamesByEmployeeId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/dependents/names`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IDependentNameDtoFromJSON));
    }

    /**
     * Get dependent names by employee ID
     */
    async getDependentNamesByEmployeeId(requestParameters: GetDependentNamesByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IDependentNameDto>> {
        const response = await this.getDependentNamesByEmployeeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDependentNamesByEmployeeId1Raw(requestParameters: GetDependentNamesByEmployeeId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IDependentNameDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getDependentNamesByEmployeeId1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dependents/names`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IDependentNameDtoFromJSON));
    }

    /**
     */
    async getDependentNamesByEmployeeId1(requestParameters: GetDependentNamesByEmployeeId1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IDependentNameDto>> {
        const response = await this.getDependentNamesByEmployeeId1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dependents by employee ID
     */
    async getDependentsByEmployeeIdRaw(requestParameters: GetDependentsByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentResponseDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getDependentsByEmployeeId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/dependents/employee/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDependentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get dependents by employee ID
     */
    async getDependentsByEmployeeId(requestParameters: GetDependentsByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentResponseDto> {
        const response = await this.getDependentsByEmployeeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDependentsByEmployeeId2Raw(requestParameters: GetDependentsByEmployeeId2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDependentInfoDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getDependentsByEmployeeId2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/dependents/employee/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDependentInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDependentsByEmployeeId2(requestParameters: GetDependentsByEmployeeId2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDependentInfoDto> {
        const response = await this.getDependentsByEmployeeId2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get public employee information by ID (secure, hides bad employees)
     */
    async getEmployee1Raw(requestParameters: GetEmployee1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicEmployeeInfoDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getEmployee1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPublicEmployeeInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get public employee information by ID (secure, hides bad employees)
     */
    async getEmployee1(requestParameters: GetEmployee1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicEmployeeInfoDto> {
        const response = await this.getEmployee1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmployeeInfoRaw(requestParameters: GetEmployeeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoResponseDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getEmployeeInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/employees/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeInfoResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getEmployeeInfo(requestParameters: GetEmployeeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoResponseDto> {
        const response = await this.getEmployeeInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get public employee information by ID (internal, returns de-identified data for bad employees)
     */
    async getEmployeeInternalRaw(requestParameters: GetEmployeeInternalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicEmployeeInfoDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getEmployeeInternal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/internal`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPublicEmployeeInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get public employee information by ID (internal, returns de-identified data for bad employees)
     */
    async getEmployeeInternal(requestParameters: GetEmployeeInternalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicEmployeeInfoDto> {
        const response = await this.getEmployeeInternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get employee personal information by ID
     */
    async getEmployeePersonalInfo1Raw(requestParameters: GetEmployeePersonalInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeePersonalInfoDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getEmployeePersonalInfo1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/personal-info/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeePersonalInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get employee personal information by ID
     */
    async getEmployeePersonalInfo1(requestParameters: GetEmployeePersonalInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeePersonalInfoDto> {
        const response = await this.getEmployeePersonalInfo1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get employee SSN by ID
     */
    async getEmployeeSsnRaw(requestParameters: GetEmployeeSsnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ISsnInfoDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getEmployeeSsn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/employees/{employee-id}/ssn`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ISsnInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get employee SSN by ID
     */
    async getEmployeeSsn(requestParameters: GetEmployeeSsnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISsnInfoDto> {
        const response = await this.getEmployeeSsnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get employee view information by ID
     */
    async getEmployeeViewRaw(requestParameters: GetEmployeeViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeViewDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getEmployeeView().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/employee-view`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeViewDtoFromJSON(jsonValue));
    }

    /**
     * Get employee view information by ID
     */
    async getEmployeeView(requestParameters: GetEmployeeViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeViewDto> {
        const response = await this.getEmployeeViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get employee names by list of IDs
     */
    async getEmployeesNamesByIdsRaw(requestParameters: GetEmployeesNamesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmployeeNameDto>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getEmployeesNamesByIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/names`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEmployeeNameDtoFromJSON));
    }

    /**
     * Get employee names by list of IDs
     */
    async getEmployeesNamesByIds(requestParameters: GetEmployeesNamesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmployeeNameDto>> {
        const response = await this.getEmployeesNamesByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLinkedEmployeesRaw(requestParameters: GetLinkedEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeLinkResponseDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getLinkedEmployees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/link`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeLinkResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getLinkedEmployees(requestParameters: GetLinkedEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeLinkResponseDto> {
        const response = await this.getLinkedEmployeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMobileAppFeedbackConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IMobileAppFeedbackReminderResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/mobile-app/feedback/config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IMobileAppFeedbackReminderResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getMobileAppFeedbackConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IMobileAppFeedbackReminderResponseDto> {
        const response = await this.getMobileAppFeedbackConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPersonRaw(requestParameters: GetPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPersonInfoDto>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xDETAILSRESOLVERS'] != null) {
            headerParameters['X-DETAILS-RESOLVERS'] = Array.from(requestParameters['xDETAILSRESOLVERS'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/persons/{person-id}`;
        urlPath = urlPath.replace(`{${"person-id"}}`, encodeURIComponent(String(requestParameters['personId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPersonInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPerson(requestParameters: GetPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPersonInfoDto> {
        const response = await this.getPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async linkEmployeesRaw(requestParameters: LinkEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeLinkResponseDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling linkEmployees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/link`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeLinkResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async linkEmployees(requestParameters: LinkEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeLinkResponseDto> {
        const response = await this.linkEmployeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async linkEmployeesSearchRaw(requestParameters: LinkEmployeesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ILinkedEmployeeInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        if (requestParameters['birthOn'] != null) {
            queryParameters['birth_on'] = (requestParameters['birthOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ssn'] != null) {
            queryParameters['ssn'] = requestParameters['ssn'];
        }

        if (requestParameters['employerEmployeeId'] != null) {
            queryParameters['employer_employee_id'] = requestParameters['employerEmployeeId'];
        }

        if (requestParameters['partnerEmployeeId'] != null) {
            queryParameters['partner_employee_id'] = requestParameters['partnerEmployeeId'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/linkage-search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ILinkedEmployeeInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async linkEmployeesSearch(requestParameters: LinkEmployeesSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ILinkedEmployeeInfoDto> {
        const response = await this.linkEmployeesSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch employee info
     */
    async patchEmployeeInfoRaw(requestParameters: PatchEmployeeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoPatchDto>> {
        if (requestParameters['iEmployeeInfoPatchDto'] == null) {
            throw new runtime.RequiredError(
                'iEmployeeInfoPatchDto',
                'Required parameter "iEmployeeInfoPatchDto" was null or undefined when calling patchEmployeeInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/employees`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployeeInfoPatchDtoToJSON(requestParameters['iEmployeeInfoPatchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeInfoPatchDtoFromJSON(jsonValue));
    }

    /**
     * Patch employee info
     */
    async patchEmployeeInfo(requestParameters: PatchEmployeeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoPatchDto> {
        const response = await this.patchEmployeeInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch employee info
     */
    async patchEmployeeInfo1Raw(requestParameters: PatchEmployeeInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeInfoAdminPatchDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling patchEmployeeInfo1().'
            );
        }

        if (requestParameters['iEmployeeInfoAdminPatchDto'] == null) {
            throw new runtime.RequiredError(
                'iEmployeeInfoAdminPatchDto',
                'Required parameter "iEmployeeInfoAdminPatchDto" was null or undefined when calling patchEmployeeInfo1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ui/employees/{employee-id}`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployeeInfoAdminPatchDtoToJSON(requestParameters['iEmployeeInfoAdminPatchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeInfoAdminPatchDtoFromJSON(jsonValue));
    }

    /**
     * Patch employee info
     */
    async patchEmployeeInfo1(requestParameters: PatchEmployeeInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeInfoAdminPatchDto> {
        const response = await this.patchEmployeeInfo1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async personForgotUsernameRaw(requestParameters: PersonForgotUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iForgotUsernameRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iForgotUsernameRequestDto',
                'Required parameter "iForgotUsernameRequestDto" was null or undefined when calling personForgotUsername().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/persons/usernames/forgot`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IForgotUsernameRequestDtoToJSON(requestParameters['iForgotUsernameRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async personForgotUsername(requestParameters: PersonForgotUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.personForgotUsernameRaw(requestParameters, initOverrides);
    }

    /**
     */
    async personVerifyCodeFromLinkRaw(requestParameters: PersonVerifyCodeFromLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVerificationCodeValidationResponseDto>> {
        if (requestParameters['iLinkVerificationCodeValidationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iLinkVerificationCodeValidationRequestDto',
                'Required parameter "iLinkVerificationCodeValidationRequestDto" was null or undefined when calling personVerifyCodeFromLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/emails/confirmation`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ILinkVerificationCodeValidationRequestDtoToJSON(requestParameters['iLinkVerificationCodeValidationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IVerificationCodeValidationResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async personVerifyCodeFromLink(requestParameters: PersonVerifyCodeFromLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVerificationCodeValidationResponseDto> {
        const response = await this.personVerifyCodeFromLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reactivate dependent
     */
    async reactivateDependentRaw(requestParameters: ReactivateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dependentId'] == null) {
            throw new runtime.RequiredError(
                'dependentId',
                'Required parameter "dependentId" was null or undefined when calling reactivateDependent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/dependents/{dependent-id}/reactivate`;
        urlPath = urlPath.replace(`{${"dependent-id"}}`, encodeURIComponent(String(requestParameters['dependentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reactivate dependent
     */
    async reactivateDependent(requestParameters: ReactivateDependentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reactivateDependentRaw(requestParameters, initOverrides);
    }

    /**
     * Search employees with employer info for admin use
     */
    async searchAdminEmployeeRaw(requestParameters: SearchAdminEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageEmployeeEmployerInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        if (requestParameters['birthOn'] != null) {
            queryParameters['birth_on'] = (requestParameters['birthOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ssn'] != null) {
            queryParameters['ssn'] = requestParameters['ssn'];
        }

        if (requestParameters['employerEmployeeId'] != null) {
            queryParameters['employer_employee_id'] = requestParameters['employerEmployeeId'];
        }

        if (requestParameters['partnerEmployeeId'] != null) {
            queryParameters['partner_employee_id'] = requestParameters['partnerEmployeeId'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/admin/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageEmployeeEmployerInfoDtoFromJSON(jsonValue));
    }

    /**
     * Search employees with employer info for admin use
     */
    async searchAdminEmployee(requestParameters: SearchAdminEmployeeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageEmployeeEmployerInfoDto> {
        const response = await this.searchAdminEmployeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search employee IDs for admin use
     */
    async searchAdminEmployeeIdsRaw(requestParameters: SearchAdminEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        if (requestParameters['birthOn'] != null) {
            queryParameters['birth_on'] = (requestParameters['birthOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ssn'] != null) {
            queryParameters['ssn'] = requestParameters['ssn'];
        }

        if (requestParameters['employerEmployeeId'] != null) {
            queryParameters['employer_employee_id'] = requestParameters['employerEmployeeId'];
        }

        if (requestParameters['partnerEmployeeId'] != null) {
            queryParameters['partner_employee_id'] = requestParameters['partnerEmployeeId'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/search/ids`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Search employee IDs for admin use
     */
    async searchAdminEmployeeIds(requestParameters: SearchAdminEmployeeIdsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.searchAdminEmployeeIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search employees with public info (hides bad employees)
     */
    async searchEmployee2Raw(requestParameters: SearchEmployee2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicEmployeeInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        if (requestParameters['birthOn'] != null) {
            queryParameters['birth_on'] = (requestParameters['birthOn'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ssn'] != null) {
            queryParameters['ssn'] = requestParameters['ssn'];
        }

        if (requestParameters['employerEmployeeId'] != null) {
            queryParameters['employer_employee_id'] = requestParameters['employerEmployeeId'];
        }

        if (requestParameters['partnerEmployeeId'] != null) {
            queryParameters['partner_employee_id'] = requestParameters['partnerEmployeeId'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPublicEmployeeInfoDtoFromJSON(jsonValue));
    }

    /**
     * Search employees with public info (hides bad employees)
     */
    async searchEmployee2(requestParameters: SearchEmployee2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicEmployeeInfoDto> {
        const response = await this.searchEmployee2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start orphan process
     */
    async signUpSsoUserRaw(requestParameters: SignUpSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPublicEmployeeInfoDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling signUpSsoUser().'
            );
        }

        if (requestParameters['iSsoUserSignUpDto'] == null) {
            throw new runtime.RequiredError(
                'iSsoUserSignUpDto',
                'Required parameter "iSsoUserSignUpDto" was null or undefined when calling signUpSsoUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/sso-signup`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ISsoUserSignUpDtoToJSON(requestParameters['iSsoUserSignUpDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPublicEmployeeInfoDtoFromJSON(jsonValue));
    }

    /**
     * Start orphan process
     */
    async signUpSsoUser(requestParameters: SignUpSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPublicEmployeeInfoDto> {
        const response = await this.signUpSsoUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an authorized user
     */
    async updateAuthorizedUserRaw(requestParameters: UpdateAuthorizedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAuthorizedUserDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAuthorizedUser().'
            );
        }

        if (requestParameters['iUpdateAuthorizedUserDto'] == null) {
            throw new runtime.RequiredError(
                'iUpdateAuthorizedUserDto',
                'Required parameter "iUpdateAuthorizedUserDto" was null or undefined when calling updateAuthorizedUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/authorized-users/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IUpdateAuthorizedUserDtoToJSON(requestParameters['iUpdateAuthorizedUserDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAuthorizedUserDtoFromJSON(jsonValue));
    }

    /**
     * Update an authorized user
     */
    async updateAuthorizedUser(requestParameters: UpdateAuthorizedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAuthorizedUserDto> {
        const response = await this.updateAuthorizedUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update beneficiaries for an employee
     */
    async updateBeneficiariesRaw(requestParameters: UpdateBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IBeneficiaryDto>>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling updateBeneficiaries().'
            );
        }

        if (requestParameters['iBeneficiaryUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iBeneficiaryUpdateDto',
                'Required parameter "iBeneficiaryUpdateDto" was null or undefined when calling updateBeneficiaries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/beneficiaries`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['iBeneficiaryUpdateDto']!.map(IBeneficiaryUpdateDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IBeneficiaryDtoFromJSON));
    }

    /**
     * Update beneficiaries for an employee
     */
    async updateBeneficiaries(requestParameters: UpdateBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IBeneficiaryDto>> {
        const response = await this.updateBeneficiariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update employee autopay properties
     */
    async updateEmployeeAutopayPropertiesRaw(requestParameters: UpdateEmployeeAutopayPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeAutopayPropertiesDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling updateEmployeeAutopayProperties().'
            );
        }

        if (requestParameters['iEmployeeAutopayPropertiesDto'] == null) {
            throw new runtime.RequiredError(
                'iEmployeeAutopayPropertiesDto',
                'Required parameter "iEmployeeAutopayPropertiesDto" was null or undefined when calling updateEmployeeAutopayProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/claim-config`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployeeAutopayPropertiesDtoToJSON(requestParameters['iEmployeeAutopayPropertiesDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeAutopayPropertiesDtoFromJSON(jsonValue));
    }

    /**
     * Update employee autopay properties
     */
    async updateEmployeeAutopayProperties(requestParameters: UpdateEmployeeAutopayPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeAutopayPropertiesDto> {
        const response = await this.updateEmployeeAutopayPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set or remove fraud review flag for an employee
     */
    async updateFraudReviewStatus1Raw(requestParameters: UpdateFraudReviewStatus1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling updateFraudReviewStatus1().'
            );
        }

        if (requestParameters['iFraudReviewRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iFraudReviewRequestDto',
                'Required parameter "iFraudReviewRequestDto" was null or undefined when calling updateFraudReviewStatus1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/{employee-id}/fraud-review`;
        urlPath = urlPath.replace(`{${"employee-id"}}`, encodeURIComponent(String(requestParameters['employeeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IFraudReviewRequestDtoToJSON(requestParameters['iFraudReviewRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set or remove fraud review flag for an employee
     */
    async updateFraudReviewStatus1(requestParameters: UpdateFraudReviewStatus1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFraudReviewStatus1Raw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLinkedCognitoRaw(requestParameters: UpdateLinkedCognitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employees/update-linked`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLinkedCognito(requestParameters: UpdateLinkedCognitoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLinkedCognitoRaw(requestParameters, initOverrides);
    }

    /**
     * Upload combine hsa document file
     */
    async uploadCombineHsaDocFileRaw(requestParameters: UploadCombineHsaDocFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICombineHsaFileResponseDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling uploadCombineHsaDocFile().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadCombineHsaDocFile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee-id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/combine-hsa/file-upload`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICombineHsaFileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Upload combine hsa document file
     */
    async uploadCombineHsaDocFile(requestParameters: UploadCombineHsaDocFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICombineHsaFileResponseDto> {
        const response = await this.uploadCombineHsaDocFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyCodeRaw(requestParameters: VerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IVerificationCodeValidationResponseDto>> {
        if (requestParameters['iVerificationCodeValidationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iVerificationCodeValidationRequestDto',
                'Required parameter "iVerificationCodeValidationRequestDto" was null or undefined when calling verifyCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/codes/verifications/validation`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IVerificationCodeValidationRequestDtoToJSON(requestParameters['iVerificationCodeValidationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IVerificationCodeValidationResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async verifyCode(requestParameters: VerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IVerificationCodeValidationResponseDto> {
        const response = await this.verifyCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyPersonRegistrationRaw(requestParameters: VerifyPersonRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPersonRegistrationVerifyResponseDto>> {
        if (requestParameters['iPersonRegistrationVerifyRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iPersonRegistrationVerifyRequestDto',
                'Required parameter "iPersonRegistrationVerifyRequestDto" was null or undefined when calling verifyPersonRegistration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/registration/verification`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPersonRegistrationVerifyRequestDtoToJSON(requestParameters['iPersonRegistrationVerifyRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPersonRegistrationVerifyResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async verifyPersonRegistration(requestParameters: VerifyPersonRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPersonRegistrationVerifyResponseDto> {
        const response = await this.verifyPersonRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyUsernamesRegistrationRaw(requestParameters: VerifyUsernamesRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iUsernameRegistrationVerifyRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iUsernameRegistrationVerifyRequestDto',
                'Required parameter "iUsernameRegistrationVerifyRequestDto" was null or undefined when calling verifyUsernamesRegistration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/registration/usernames/verification`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IUsernameRegistrationVerifyRequestDtoToJSON(requestParameters['iUsernameRegistrationVerifyRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async verifyUsernamesRegistration(requestParameters: VerifyUsernamesRegistrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyUsernamesRegistrationRaw(requestParameters, initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum DeleteByEmployeeIdAndTypeTypeEnum {
    PRIMARY = 'PRIMARY',
    CONTINGENT = 'CONTINGENT'
}
/**
  * @export
  * @enum {string}
  */
export enum GetByEmployeeId1StatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDependentStatusesEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDependent1StatusesEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDependentsByEmployeeIdStatusesEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPersonXDetailsResolversEnum {
    DEPENDENT = 'DEPENDENT',
    SSN = 'SSN',
    ADDRESS = 'ADDRESS'
}
/**
  * @export
  * @enum {string}
  */
export enum LinkEmployeesSearchStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchAdminEmployeeStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchAdminEmployeeIdsStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum SearchEmployee2StatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
